import React from 'react';
import { STYLE_SCHEMA } from './styleSchema';

export function StyleEditor({ element, onChange }) {
  if (!element) {
    return (
      <div style={panelStyle}>
        <h3>No selection</h3>
        <p>Select an element to edit styles</p>
      </div>
    );
  }

  const { style = {}, type } = element;

  return (
    <div style={panelStyle}>
      <h3>{type.toUpperCase()} STYLES</h3>

      {Object.entries(STYLE_SCHEMA).map(([key, config]) => {
        // Filter by element type
        if (config.onlyFor && !config.onlyFor.includes(type)) {
          return null;
        }

        const value = style[key];

        return (
          <StyleField
            key={key}
            label={config.label}
            type={config.type}
            value={value}
            config={config}
            onChange={(v) => onChange({ [key]: v })}
          />
        );
      })}
    </div>
  );
}



function StyleField({ label, type, value, config, onChange }) {
  return (
    <div style={{ marginBottom: 12 }}>
      <label style={labelStyle}>{label}</label>

     {type === 'color' && (
  <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
    <input
      type="color"
      value={value ?? '#000000'}
      disabled={value === null}
      onChange={(e) => onChange(e.target.value)}
      style={{ flex: 1 }}
    />

    <button
      type="button"
      onClick={() => onChange(value === null ? '#000000' : null)}
      style={{
        padding: '4px 8px',
        fontSize: 12,
        cursor: 'pointer',
        background: value === null ? '#1976d2' : '#eee',
        color: value === null ? '#fff' : '#000',
        border: '1px solid #ccc',
        borderRadius: 4,
      }}
    >
      {value === null ? 'Opaque' : 'Transparent'}
    </button>
  </div>
)}


      {type === 'number' && (
        <input
          type="number"
          value={value ?? ''}
          min={config.min}
          max={config.max}
          onChange={(e) => onChange(Number(e.target.value))}
        />
      )}

      {type === 'select' && (
        <select
          value={value ?? ''}
          onChange={(e) => onChange(e.target.value)}
        >
          {config.options.map((opt) =>
            typeof opt === 'string' ? (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ) : (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            )
          )}
        </select>
      )}
    </div>
  );
}



const panelStyle = {
  // width: 280, <-- REMOVE THIS
  padding: 16,
  // borderLeft: '1px solid #ddd', <-- REMOVE THIS
  background: 'transparent', // Let the sidebar handle the background
  boxSizing: 'border-box',
  flexShrink: 0, // Prevents the top editor from being squashed
};

const labelStyle = {
  display: 'block',
  fontSize: 12,
  opacity: 0.7,
  marginBottom: 4,
};
